import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { useCallback } from 'react';
export const useVoucherEligibleTld = function (enabled) {
  var _tlds$data, _account$data, _account$data2;
  if (enabled === void 0) {
    enabled = true;
  }
  const tlds = DomainsApiClient.hooks.useDomainTlds({
    disableGeoFiltering: true
  }, enabled, {
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: false
  });
  const account = DomainsApiClient.hooks.useDomainsAccount({}, enabled, {
    staleTime: Infinity,
    cacheTime: Infinity,
    useErrorBoundary: false
  });
  const resolved = (tlds.isFetched || tlds.isIdle) && (account.isFetched || account.isIdle);
  const supported = (((_tlds$data = tlds.data) == null ? void 0 : _tlds$data.tlds) ?? []).filter(_ref => {
    let {
      couponsApplicable
    } = _ref;
    return couponsApplicable;
  }).map(_ref2 => {
    let {
      tld
    } = _ref2;
    return tld;
  }).join(',');
  const promotesFreeYear = !((_account$data = account.data) != null && _account$data.isPremiumSite) || Boolean((_account$data2 = account.data) == null || (_account$data2 = _account$data2.coupons) == null ? void 0 : _account$data2.length);
  return useCallback((tld, premium) => resolved ? Boolean(tld) && !premium && promotesFreeYear && supported.split(',').includes(tld) : undefined, [resolved, supported, promotesFreeYear]);
};
//# sourceMappingURL=useVoucherEligibleTld.js.map